import React from 'react';
import PropTypes from 'prop-types';

const CustomCheckbox = ({
  field,
  form: { touched, errors, setFieldValue },
  message,
  ...props
}) => {
  const isError = touched[field.name] && errors[field.name];

  const handleChange = () => {
    setFieldValue(field.name, !field.value);
  };

  return (
    <>
      <label className='fe-form-checkbox-container'>
        <input
          type='checkbox'
          {...field}
          checked={field.value === true}
          onChange={handleChange}
          onClick={props.onClick || undefined}
        />
        <span className={`fe-form-checkbox ${isError ? 'error' : ''}`}></span>
        <span dangerouslySetInnerHTML={{ __html: message }}></span>
      </label>
    </>
  );
};

CustomCheckbox.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

CustomCheckbox.defaultProps = {

};

export default CustomCheckbox;
